/**
 * Google Maps JS API singleton loader (v2 functional API).
 *
 * All map-related components import `loadGoogleMaps()` and await it before
 * touching `window.google`. The loader is configured once (setOptions) and
 * the libraries we need (places, geocoding, geometry) are imported in
 * parallel; each component can rely on `window.google.maps.{places,geometry}`
 * being available after the promise resolves.
 */
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

let configured = false;
let loaderPromise = null;

function ensureConfigured() {
  if (configured) return;
  setOptions({
    key: API_KEY,
    v: 'weekly',
  });
  configured = true;
}

export function loadGoogleMaps() {
  if (!API_KEY) {
    return Promise.reject(new Error('Google Maps API key is not configured'));
  }
  if (!loaderPromise) {
    ensureConfigured();
    // Pre-warm every library the app uses so consumers can rely on them.
    loaderPromise = Promise.all([
      importLibrary('maps'),
      importLibrary('places'),
      importLibrary('geocoding'),
      importLibrary('geometry'),
      importLibrary('marker'),
    ]).then(() => window.google);
  }
  return loaderPromise;
}

export const HAS_GOOGLE_MAPS = !!API_KEY;
